<mat-accordion>
    <mat-expansion-panel *ngFor="let faq of faqs; let i = index" [expanded]="i === 0">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="ess-faq-question"> {{ faq.question }}</div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div [innerHTML]="faq.answer" class="ess-faq-answer"></div>
    </mat-expansion-panel>
</mat-accordion>